// extracted by mini-css-extract-plugin
export default {"calendar_table":"KanbanList_calendar_table__ufyJB"};